module.exports = __webpack_public_path__ + "img/saoyisao.240d423a.png";